export default __webpack_public_path__ + "static/bannerDefault@2x-2ca80b7f6dcffb5733b47aaa8509959e.png";